import type { SrcSet } from "@inferno/renderer-shared-core";
import { placeholderImage } from "@ihr-radioedit/inferno-core";
import { ResponsiveImage } from "../ResponsiveImage.component";
import { RESPONSIVE_IMAGE } from "../../ui/constants";

interface OnairScheduleThumbProps {
  imgUrl: string;
  alt: string;
  min?: number;
  max?: number;
  isUnenriched?: boolean;
}

export const OnairScheduleThumb = ({
  imgUrl,
  alt,
  min = 70,
  max = 140,
  isUnenriched = false,
}: OnairScheduleThumbProps) => {
  const buildOpsString = (size: number) =>
    isUnenriched
      ? `?ops=gravity(%22center%22),contain(${size},${size})`
      : `?ops=gravity(%22center%22),fit(${size},${size})`;

  const opsString1x = buildOpsString(min);
  const opsString2x = buildOpsString(max);

  const srcset: SrcSet[] = [
    {
      url: `${imgUrl}${opsString1x}`,
      descriptor: "1x",
    },
    {
      url: `${imgUrl}${opsString2x}`,
      descriptor: "2x",
    },
  ];

  return (
    <ResponsiveImage
      alt={alt}
      placeholder={`${placeholderImage}?ops=ratio(1,1)`}
      src={`${imgUrl}${opsString1x}`}
      srcset={srcset}
      initialWidth={RESPONSIVE_IMAGE.onAirScheduleThumbWidth}
      initialHeight={RESPONSIVE_IMAGE.onAirScheduleThumbHeight}
    />
  );
};
